import Link from 'next/link'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { RoundedLabel } from '@/components/elements/RoundedLabel'
import { DHeading } from '@/components/layouts/Ir/Heading'

type Props = {
  name: string
  // detail: string
  imagePath: string
  path: string
}

// export const ShareholderContent = ({ detail, imagePath, path }: Props) => {
export const ShareholderContent = ({ imagePath, path }: Props) => {
  return (
    <Section>
      <Background />
      <ImageWrapper>
        <picture>
          <source
            media="(max-width: 1047px)"
            srcSet={imagePath}
            width="335"
            height="115"
          />
          <img src={imagePath} width="640" height="220" alt="" />
        </picture>
      </ImageWrapper>
      <Content>
        <Title>
          <TitleText>{`当社の株主に\u000Aなりませんか？`}</TitleText>
          <TitleUnderline>
            <source
              media="(max-width: 1047px)"
              srcSet="/images/title-underline.svg"
              width="168"
              height="10"
            />
            <img
              src="/images/title-underline.svg"
              alt=""
              width="564"
              height="34"
            />
          </TitleUnderline>
        </Title>
        {/* <Text>{detail}</Text> */}
        <LinkWrapper>
          <Link href={path} passHref>
            <StyledLink as="a">株主になるには</StyledLink>
          </Link>
        </LinkWrapper>
      </Content>
    </Section>
  )
}

const Section = styled.section`
  display: grid;
  grid-template-rows: 81px 1fr auto;

  @media screen and (max-width: 1047px) {
    grid-template-rows: 68px 1fr auto;
  }
`

const Background = styled.div`
  background: ${theme.colors.backgroundPaleBlue};
  grid-area: 2 / 1 / 4 / 2;
`

const ImageWrapper = styled.div`
  grid-area: 1 / 1 / 3 / 2;
  width: 100%;
  margin-bottom: 51px;
  display: grid;
  place-content: center;

  @media screen and (max-width: 1047px) {
    margin-bottom: 43px;
  }
`

const Content = styled.div`
  grid-area: 3 / 1 / 4 / 2;
  display: flex;
  flex-direction: column;
  gap: 44px;
  padding-bottom: 71px;

  @media screen and (max-width: 1047px) {
    gap: 32px;
    padding: 0 20px 50px;
    margin: 0 auto;
  }
`

const Title = styled.div`
  display: grid;
  grid-template-rows: 1fr repeat(2, auto);
  place-content: center;
`

const TitleText = styled(DHeading)`
  text-align: center;
  grid-area: 1 / 1 / 3 / 2;
  position: relative;
  z-index: 2;

  @media screen and (max-width: 1047px) {
    white-space: pre-wrap;
  }
`

const TitleUnderline = styled.picture`
  grid-area: 2 / 1 / 4 / 2;
`

/*
const Text = styled.p`
  line-height: 1.9;
  text-align: center;

  @media screen and (max-width: 1047px) {
    text-align: left;
  }
`
*/

const LinkWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const StyledLink = styled(RoundedLabel)`
  width: 274px;

  &:hover {
    background: ${theme.colors.lightBlue};
  }

  @media screen and (max-width: 1047px) {
    width: auto;
  }
`
